import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "@/components/base/autoRegistrator";
import "@/plugins/sentry";
import "@/plugins/gtm";
import "@/plugins/modals/index.js";
import "@/plugins/pagination";
import ShowErrorModal from "@/mixins/ShowErrorModal";
import RequestWarningModal from "@/mixins/ShowRequestWarningModal";
import "@/plugins/vee-validate";
import "@/plugins/cleave";
import CKEditor from "@ckeditor/ckeditor5-vue2";

Vue.mixin(ShowErrorModal);
Vue.mixin(RequestWarningModal);
Vue.use(CKEditor);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
